/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppConversationMetaSchema = z.object({
	pagination: z.object({ currentPage: z.number(), lastPage: z.number(), perPage: z.number(), total: z.number() }),
	needsReplyCount: z.number(),
	unreadConversationsCount: z.number(),
})

export type WhatsAppConversationMetaSchema = z.infer<typeof whatsAppConversationMetaSchema>
